import React from 'react';
import { Button } from './ui/button';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gray-900">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1620256371969-24024f6d1510"
          alt="Flax field production in Kazakhstan"
          className="w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/60 via-gray-900/40 to-gray-900/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-8 py-40 text-center">
        <div className="mb-8">
          <div className="inline-block px-6 py-2 bg-emerald-700/20 backdrop-blur-sm border border-emerald-600/30 rounded-full mb-8">
            <p className="text-emerald-300 text-sm font-medium tracking-wide uppercase">Agricultural Commodity Trading</p>
          </div>
        </div>
        
        <h1 className="text-6xl md:text-8xl font-light text-white mb-10 leading-tight tracking-tight">
          Irgiz Export
        </h1>
        
        <p className="text-2xl md:text-3xl text-white/90 mb-16 font-light max-w-4xl mx-auto leading-relaxed">
          Reliable supply of agricultural commodities from Northern Kazakhstan to international markets
        </p>
        
        <Button
          onClick={scrollToContact}
          size="lg"
          className="bg-emerald-700 hover:bg-emerald-600 text-white px-12 py-7 text-lg font-normal rounded-sm transition-all duration-300 shadow-2xl hover:shadow-emerald-900/50 tracking-wide"
        >
          Get in Touch
        </Button>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
